'use client';

import { createContext, ReactNode } from 'react';

import type { PublicFeatureFlags } from '@/server/utils/featureFlags';

export const FeatureFlagsContext = createContext<PublicFeatureFlags | undefined>(undefined);

type FeatureFlagsProviderProps = {
  children: ReactNode;
  flags: PublicFeatureFlags;
};

export const FeatureFlagsProvider = ({ children, flags }: FeatureFlagsProviderProps) => {
  return <FeatureFlagsContext.Provider value={flags}>{children}</FeatureFlagsContext.Provider>;
};
